<h1>Upload!</h1>

<div *ngIf="!mode">
    <button (click)="mode = 'files'">From 4d Files</button>
    <button (click)="mode = 'folder'">From 4d Folders</button>
    <div *ngIf="folder">
        <div>From local computer!</div>
        <input type="file" multiple (change)="upload($event)"/>
    </div>
</div>
<file-picker *ngIf="mode" [mode]="mode" (onCancel)="mode = null" (onSelectedFiles)="uploadFiles($event)" (onSelectedFolders)="uploadFolder($event)"></file-picker>